import React from 'react'
import HeroAboutPage from '../Components/Hero/HeroAboutPage';
import About6 from '../Components/About/AboutPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: ['Ginecologia', 'Medicina Estetica', 'Trattamenti Ginecologia', 'Servizi Estetica', 'Trattamenti Viso'],
};

const aboutData = {
    title:
        'Mi chiamo Rosa Coppola, sono Ginecologa e Medico Estetico, e dedico la mia professione al benessere delle donne in ogni fase della loro vita.',
    avater: {
        img: 'images/avatar1.png',
        name: 'Dott.ssa Rosa Coppola',
        designation: 'Ginecologa e Medico Estetico',
    },
    timeTable: [
        {
            day: 'Luned�',
            startTime: '08:00',
            endTime: '19:00',
        },
        {
            day: 'Marted�',
            startTime: '09:00',
            endTime: '18:00',
        },
        {
            day: 'Mercoled�',
            startTime: '09:00',
            endTime: '18:00',
        },
        {
            day: 'Gioved�',
            startTime: '08:00',
            endTime: '19:00',
        },
        {
            day: 'Venerd�',
            startTime: '09:00',
            endTime: '17:00',
        },
        {
            day: 'Sabato',
            startTime: '08:00',
            endTime: '19:00',
        },
        {
            day: 'Domenica',
            startTime: '09:00',
            endTime: '15:00',
        },
    ],
    contact: '+39 348 692 7058',
};

const AboutPage = () => {
  return (
    <>
      <HeroAboutPage data={heroData} />
      <About6 data={aboutData} />
    </>
  )
}

export default AboutPage
